import { createActorContext } from '@xstate/react';

import {
  extensionPurchaseReqNumberMachine,
  ExtensionPurchaseReqNumberSnapshot,
} from './extensionPurchaseReqNumberMachine';

export const ExtensionPurchaseReqNumberContext = createActorContext(extensionPurchaseReqNumberMachine);

export const useExtensionPurchaseReqNumberActorRef = () => ExtensionPurchaseReqNumberContext.useActorRef();

export const useExtensionPurchaseReqNumberSelector = <T>(
  selector: (snapshot: ExtensionPurchaseReqNumberSnapshot) => T,
): T => ExtensionPurchaseReqNumberContext.useSelector(selector);
